import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { UserInfo } from "./userSlice";
import { executeUserInvite } from "./userInviteSlice";

export interface UsersPermissionsInsState {
  state: LoadStateInfo;
  request?: ExecuteUsersPermissionsInsRequest;
}

const initialState: UsersPermissionsInsState = {
  state: notStarted(),
};

export interface ExecuteUsersPermissionsInsRequest {
  users: UserInfo[];
  targetId: string;
  permissionIds: string[];
}

export const executeUsersPermissionsIns = createAsyncThunk(
  "executeUsersPermissionsIns",
  async (params: ExecuteUsersPermissionsInsRequest, thunkAPI) => {
    console.debug(`Execute permissions ${params.permissionIds} for users ${params.users} on target ${params.targetId}`);

    const body = {
      targetId: params.targetId,
      permissionIds: params.permissionIds,
      userIds: params.users.map((user) => user.uid)
    };

    const response = await fetch(`${getBackendUrl()}/api/user/permission/add`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body)
    });

    if(response.ok) {
      return "Ok";
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const usersPermissionsInsSlice = createSlice({
  name: "executeUsersPermissionsInsSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.request = undefined;
    },
    clearState: (state) => {
      state.state = notStarted();
    },
    // add: (state, action: PayloadAction<UserInfo>) => {
    //   if(state.request) {
    //     if (state.request.users.filter((user) => user.uid === action.payload.uid).length === 0) {
    //       state.request.users.push(action.payload);
    //     }
    //     state.request.users.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    //   } else {
    //     console.error("Request is empty");
    //   }
    // },
    // remove: (state, action: PayloadAction<UserInfo>) => {
    //   if(state.request) {
    //     state.request.users = state.request.users.filter((user) => user.uid !== action.payload.uid);
    //   }
    // },
    // setTarget: (state, action: PayloadAction<string>) => {
    //   state.request = {users: [], targetId: action.payload, permissionIds: []};
    // },
    // addPermission: (state, action: PayloadAction<string>) => {
    //   if(state.request) {
    //     state.request.permissionIds.push(action.payload);
    //   }
    // },
    // removePermission: (state, action: PayloadAction<string>) => {
    //   if(state.request) {
    //     state.request.permissionIds = state.request.permissionIds.filter((permissionId) => permissionId !== action.payload);
    //   }
    // },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(executeUsersPermissionsIns.pending, (state, action) => {
        state.state =  loading();
        state.request = action.meta.arg;
      })
      .addCase(executeUsersPermissionsIns.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
      })
      .addCase(executeUsersPermissionsIns.rejected, (state, action) => {
        state.state = error(action);
      })
    //   .addCase(executeUserInvite.fulfilled, (state, action) => {
    //     console.debug(`${action.type}`);
    //     if(state.request) {
    //       for(const newUser of action.payload) {
    //         if (state.request.users.filter((user) => user.uid === newUser.uid).length === 0) {
    //           state.request.users.push(newUser);
    //         }
    //       }
    //       state.request.users.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
    //     } else {
    //       console.error("Request is empty");
    //     }
    //   })
      ;
    },
});

export const {} = usersPermissionsInsSlice.actions;

export const selectUsersPermissionsIns = (state: RootState) => state.usersPermissionsIns;

export default usersPermissionsInsSlice.reducer;
